import { Flex } from "@redotech/redo-web/flex";
import classNames from "classnames";
import { memo, ReactNode } from "react";
import * as css from "./phone-frame.module.css";

export type PhoneFrameSize = "compact" | "full";

/**
 * Presentational phone bezel used to preview a mobile post-purchase upsell page.
 * Shared by the PPU builder canvas and the checkout-tree node hover preview so
 * the two surfaces stay visually in sync. The frame is a fixed device size (its
 * height derives from a fixed width via a pinned aspect ratio); when it is
 * taller than its container it is cut off and the container scrolls. `compact`
 * scales the whole frame down to fit the hover card; `full` is the roomier
 * builder-canvas size.
 */
export const PhoneFrame = memo(function PhoneFrame({
  children,
  size = "compact",
}: {
  children: ReactNode;
  size?: PhoneFrameSize;
}) {
  const fill = size === "full";
  return (
    <Flex
      className={
        fill ? css.phoneFrame : classNames(css.phoneFrame, css.compact)
      }
      dir="column"
      maxW="full"
      minH="none"
      p="sm"
      shrink="0"
      w="xxs"
    >
      <Flex
        className={css.phoneScreen}
        dir="column"
        gap="none"
        grow="1"
        minH="none"
      >
        {children}
      </Flex>
    </Flex>
  );
});
